import { atom } from "jotai";
import { ApiLimits } from "src/api/types";
import useApi, { emptyApiState } from "src/hooks/api/utils/useApi";

const stateAtom: any = atom(emptyApiState);

function useLimits() {
	const { state, actions, api } = useApi(stateAtom, {
		baseUrl: `/company/limits`,
		query: {},
	});

	const limits: ApiLimits = state?.data || {};

	return {
		limits,
		status: state.status,
		actions,
		api,
	};
}

export default useLimits;
